import { trending, deepEvent } from "@/mocks/gossip";

const HERO_BG =
  "https://readdy.ai/api/search-image?query=editorial%20newsroom%20archive%20wall%20with%20warm%20coral%20and%20deep%20teal%20accent%20lighting%2C%20stylized%20abstract%20gradient%20shapes%20and%20timeline%20dots%2C%20vintage%20magazine%20dramatic%20atmosphere%20with%20soft%20bokeh&width=1600&height=1000&seq=hero&orientation=landscape";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="吃瓜大全编辑资料库氛围背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/60 to-background-950/90"></div>
      </div>

      <div className="relative mx-auto flex min-h-[88vh] w-full max-w-7xl flex-col justify-center px-4 pb-14 pt-28 md:px-6 lg:px-10">
        <div className="w-full max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm md:text-sm">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-300 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
            </span>
            今日已同步 6 条新事件 · 资料库持续扩充中
          </div>

          <h1 className="font-heading mt-6 text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
            一个吃瓜，一份
            <span className="text-accent-300">完整存档</span>
            <br className="hidden md:block" />
            从源头看到尾声
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            吃瓜大全把深度爆料按事件完整归档：按时间线还原首曝、发酵、多方回应到收尾的全过程。
            内幕汇总、资料库随热点随时扩充，想一次吃透一个瓜，从这里开始。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#archive"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              进入完整存档
              <i className="ri-arrow-right-line text-base"></i>
            </a>
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              <i className="ri-time-line text-base"></i>
              看深扒时间线
            </a>
          </div>

          <div className="mt-9 flex flex-wrap items-center gap-2">
            <span className="mr-1 text-xs font-medium tracking-wider text-background-200/80">实时热瓜</span>
            {trending.map((t) => (
              <a
                key={t.title}
                href="#hot"
                className="group inline-flex items-center gap-1.5 rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1.5 text-xs text-background-100 whitespace-nowrap backdrop-blur-sm transition-colors hover:border-accent-300/60 hover:bg-background-50/20"
              >
                <span className="rounded-full bg-primary-500 px-1.5 py-0.5 text-[10px] font-bold text-background-50">
                  {t.tag}
                </span>
                <span className="max-w-[8rem] truncate">{t.title}</span>
                <i className="ri-arrow-up-line text-accent-300 group-hover:translate-x-0.5"></i>
              </a>
            ))}
          </div>
        </div>

        {/* featured card strip */}
        <div className="mt-12 grid w-full grid-cols-1 gap-3 sm:grid-cols-3">
          {[
            { num: "01", label: "溯源标注", desc: "每条信息都标清信源等级" },
            { num: "02", label: "全链归档", desc: "源头到尾声一页理清" },
            { num: "03", label: "动态更新", desc: "出现新节点即刻追加" },
          ].map((f) => (
            <div
              key={f.num}
              className="rounded-2xl border border-background-50/15 bg-background-50/10 px-5 py-4 backdrop-blur-sm"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-2xl font-black text-accent-300">{f.num}</span>
                <i className="ri-layout-grid-fill text-accent-300"></i>
              </div>
              <div className="mt-2 text-sm font-semibold text-background-50">{f.label}</div>
              <div className="mt-1 text-xs text-background-100/80">{f.desc}</div>
            </div>
          ))}
        </div>
        <a href={deepEvent ? "#timeline" : "#archive"} className="mt-6 inline-flex text-xs text-accent-300 hover:text-accent-200">
          ↓ 滚动查看今日深扒主角：{deepEvent.title}
        </a>
      </div>
    </section>
  );
}